import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { InputLabel } from '@material-ui/core';
import { InputProps } from './types';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { RichTextEditor } from '../Shared/Form';
import { ErrorMessage } from '../Services/styled-components';

interface HtmlEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
  label: string;
}

function HtmlEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
}: HtmlEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <InputLabel error={Boolean(fieldState.error)}>{label}</InputLabel>
          <RichTextEditor modules={null} onChange={field.onChange} value={field?.value} />
          <ErrorMessage>{fieldState.error?.message}</ErrorMessage>
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

export default HtmlEditor;
